import React from "react";
export const ListboxContext = React.createContext({
    listboxItemInvoked: null,
    listboxItemFocused: null,
    listboxSelectedItems: [],
    listboxMultiselectable: false,
});
